import { render } from "./partnerLevelCard.vue?vue&type=template&id=e3dea580"
import script from "./partnerLevelCard.vue?vue&type=script&lang=js"
export * from "./partnerLevelCard.vue?vue&type=script&lang=js"

import "./partnerLevelCard.vue?vue&type=style&index=0&id=e3dea580&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__